import { render, staticRenderFns } from "./WiseView.vue?vue&type=template&id=f1d8413a&"
import script from "./WiseView.vue?vue&type=script&lang=js&"
export * from "./WiseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports